import cloudprint from "~/service/cloudprint";

/**
 * notifier:
 * {
 *     status: 0 已提交任务 1 已回调
 *     listeners: [] 打印结果回调的监听器
 *     response 打印结果
 *     platform 来自哪个打印组件
 *
 * }
 */

/**
 * listener:
 * {
 *     tag: 'PRINT_RESULT' 、'DELAY_PRINT',
 *     callback: 执行的函数
 * }
 */

/**
 * key: documentID(waybillId)
 * value: notifier
 *
 * @type {Map<any, any>}
 */
const printNotifierMap = new Map()
const listenerCacheMap = new Map()

const addNotifier = (documentID, platform) => {
    if (!printNotifierMap.has(documentID)) {
        printNotifierMap.set(documentID, {
            status: 0,
            platform: platform,
            listeners: listenerCacheMap.get(documentID) ? listenerCacheMap.get(documentID) : [],
            response: null,
            createdTime: new Date().getTime()
        })
    }
    listenerCacheMap.delete(documentID)
}

const deleteNotifier = (documentID) => {
    printNotifierMap.delete(documentID)
}

const addListener = (documentID, tag, callback) => {
    const listener = {
        tag,
        callback
    }
    const notifier = printNotifierMap.get(documentID)
    if (!notifier) {
        // 有可能加listener的时候，notifier还没有添加，先缓存下来
        listenerCacheMap.set(documentID, listenerCacheMap.get(documentID) ? [...listenerCacheMap.get(documentID), listener] : [listener])
        return
    }
    notifier.listeners.push(listener)
}

const delayPrintJob = (printDataList, printerName) => {
    // 找到当前最后执行的任务
    const lastPrint = Array.from(printNotifierMap.entries()).reduce((lastJob, [key, value]) => {
        if (!lastJob || (lastJob.value && (lastJob.value.createdTime < value.createdTime))) {
            return {key, value}
        }
        return lastJob
    }, null)
    if (!lastPrint) return
    const {key} = lastPrint
    // console.log('lastPrint', lastPrint)
    addListener(key, 'DELAY_PRINT', response => {
        cloudprint.doPrintBath(printDataList, printerName)
    })
}

const clearAllNotifiers = () => {
    printNotifierMap.clear()
}

const getPrinterNotifierEntries = () => {
    return printNotifierMap.entries()
}

const setNotifierResponse = (documentID, response) => {
    const notifier = printNotifierMap.get(documentID)
    if (!notifier) return
    notifier.response = response
    notifier.status = 1
}

const notifyListeners = (documentID) => {
    const notifier = printNotifierMap.get(documentID)
    if (!notifier) return
    printNotifierMap.delete(documentID)
    const {response} = notifier
    while (true) {
        const listener = notifier.listeners.shift()
        if (!!listener) {
            const {callback} = listener
            callback(response)
        } else {
            break
        }
    }
}

export default {
    addNotifier,
    addListener,
    getPrinterNotifierEntries,
    delayPrintJob,
    notifyListeners,
    setNotifierResponse,
    deleteNotifier,
    clearAllNotifiers
}


// WEBPACK FOOTER //
// ./src/utils/printerNotifier.js